(() => {
  if (window.TPProductCardQuantityPickerV2) return;
  window.TPProductCardQuantityPickerV2 = true;

  const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');
  const OPEN_BUTTON_SELECTOR = '[data-tp-card-buy-open]';
  const FORM_COMPONENT_SELECTOR = 'product-form[data-tp-card-picker]';
  const QUANTITY_INPUT_SELECTOR = '[data-tp-card-quantity-input]';

  let root = null;
  let panel = null;
  let backdrop = null;
  let active = null;
  let previousBodyOverflow = '';

  function ensurePicker() {
    if (root) return;

    root = document.createElement('div');
    root.className = 'tp-card-picker-root';
    root.hidden = true;
    root.innerHTML = `
      <div class="tp-card-picker-backdrop" data-tp-picker-backdrop></div>

      <div
        class="tp-card-picker-panel"
        data-tp-picker-panel
        role="dialog"
        aria-modal="false"
        aria-labelledby="tp-card-picker-heading"
      >
        <div class="tp-card-picker-drag" aria-hidden="true"></div>

        <div class="tp-card-picker-product">
          <div class="tp-card-picker-product__media" data-tp-picker-media>
            <img data-tp-picker-image alt="" loading="eager">
          </div>

          <div class="tp-card-picker-product__title" data-tp-picker-product-title></div>

          <button
            type="button"
            class="tp-card-picker-close"
            data-tp-picker-close
            aria-label="Cerrar"
          >×</button>
        </div>

        <div class="tp-card-picker-heading" id="tp-card-picker-heading" data-tp-picker-heading></div>

        <div class="tp-card-picker-options">
          <button type="button" class="tp-card-picker-option" data-tp-picker-qty="1">
            <span class="tp-card-picker-option__label" data-tp-picker-label-1></span>
            <span class="tp-card-picker-option__price tp-card-picker-option__price--single" data-tp-picker-price-1></span>
          </button>

          <button type="button" class="tp-card-picker-option" data-tp-picker-qty="3">
            <span class="tp-card-picker-option__label" data-tp-picker-label-3></span>
            <span class="tp-card-picker-option__save" data-tp-picker-save-3></span>
            <span class="tp-card-picker-option__price-stack">
              <span class="tp-card-picker-option__compare" data-tp-picker-compare-3></span>
              <span class="tp-card-picker-option__price" data-tp-picker-price-3></span>
            </span>
          </button>

          <button type="button" class="tp-card-picker-option" data-tp-picker-qty="5">
            <span class="tp-card-picker-option__label" data-tp-picker-label-5></span>
            <span class="tp-card-picker-option__save" data-tp-picker-save-5></span>
            <span class="tp-card-picker-option__price-stack">
              <span class="tp-card-picker-option__compare" data-tp-picker-compare-5></span>
              <span class="tp-card-picker-option__price" data-tp-picker-price-5></span>
            </span>
          </button>
        </div>
        <p class="tp-card-picker-shipping">
  Envío gratis a partir de 48 €
</p>
      </div>
    `;

    document.body.appendChild(root);
    panel = root.querySelector('[data-tp-picker-panel]');
    backdrop = root.querySelector('[data-tp-picker-backdrop]');
  }

  function setText(selector, value) {
    const el = root.querySelector(selector);
    if (el) el.textContent = value || '';
  }

  function populate(productForm) {
    const d = productForm.dataset;

    setText('[data-tp-picker-heading]', d.tpChooseLabel || 'Elige tu opción');
    setText('[data-tp-picker-product-title]', d.tpProductTitle || '');

    setText('[data-tp-picker-label-1]', d.tpQtyOneLabel || '1 unidad');
setText('[data-tp-picker-label-3]', d.tpQtyThreeLabel || '3 unidades');
setText('[data-tp-picker-label-5]', d.tpQtyFiveLabel || '5 unidades');

setText('[data-tp-picker-price-1]', d.tpPriceOne || '');
setText('[data-tp-picker-compare-3]', d.tpCompareThree || '');
setText('[data-tp-picker-price-3]', d.tpPriceThree || '');
setText('[data-tp-picker-compare-5]', d.tpCompareFive || '');
setText('[data-tp-picker-price-5]', d.tpPriceFive || '');

const saveLabel = d.tpSaveLabel || 'Ahorra';
setText('[data-tp-picker-save-3]', `${saveLabel} ${d.tpSaveThree || ''}`.trim());
setText('[data-tp-picker-save-5]', `${saveLabel} ${d.tpSaveFive || ''}`.trim());

    const image = root.querySelector('[data-tp-picker-image]');
    const media = root.querySelector('[data-tp-picker-media]');
    const imageUrl = d.tpProductImage || '';

    if (image && media) {
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = d.tpProductTitle || '';
        media.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        media.hidden = true;
      }
    }

    const close = root.querySelector('[data-tp-picker-close]');
    if (close) close.setAttribute('aria-label', d.tpCloseLabel || 'Cerrar');
  }

  function lockScroll() {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('tp-card-picker-is-open');
  }

  function unlockScroll() {
    document.body.style.overflow = previousBodyOverflow;
    document.documentElement.classList.remove('tp-card-picker-is-open');
  }

  function positionDesktop() {
    if (!active || !panel || root.hidden || MOBILE_QUERY.matches) return;

    const card = active.opener.closest('product-card') || active.opener.closest('.product-card');
    const inner = card?.querySelector('[data-product-card-inner]') || card;
    const anchor = active.opener.closest('[data-product-card-buttons]') || active.opener;

    if (!inner || !anchor) return;

    const cardRect = inner.getBoundingClientRect();
    const anchorRect = anchor.getBoundingClientRect();

    const viewportGap = 8;
    let width = Math.max(250, Math.round(cardRect.width));
    width = Math.min(width, window.innerWidth - viewportGap * 2);

    let left = Math.round(cardRect.left);
    left = Math.max(viewportGap, Math.min(left, window.innerWidth - width - viewportGap));

    panel.style.width = `${width}px`;
    panel.style.left = `${left}px`;
    panel.style.top = '8px';

    const panelHeight = panel.offsetHeight;
    let top = Math.round(anchorRect.top - panelHeight - 8);

    if (top < viewportGap) {
      top = Math.round(anchorRect.bottom + 8);
    }

    const maxTop = Math.max(viewportGap, window.innerHeight - panelHeight - viewportGap);
    top = Math.min(top, maxTop);

    panel.style.top = `${top}px`;
  }

  function applyMode() {
    if (!root || !panel || !active) return;

    const isMobile = MOBILE_QUERY.matches;

    root.classList.toggle('is-mobile', isMobile);
    root.classList.toggle('is-desktop', !isMobile);
    panel.setAttribute('aria-modal', isMobile ? 'true' : 'false');

    if (isMobile) {
      panel.removeAttribute('style');
      lockScroll();
    } else {
      unlockScroll();
      requestAnimationFrame(positionDesktop);
    }
  }

  function openPicker(opener) {
    ensurePicker();

  /*
   * Si el selector de ESTA MISMA tarjeta ya está abierto,
   * el botón Comprar actúa como toggle y lo cierra.
   */
  if (
    active?.opener === opener &&
    root &&
    !root.hidden
  ) {
    closePicker(false);
    return;
  }


    const container = opener.closest('[data-product-card-buttons]');
const productForm = container?.querySelector(FORM_COMPONENT_SELECTOR);
const form = productForm?.querySelector('form');

const card =
  opener.closest('product-card') ||
  opener.closest('.product-card');

if (!container || !productForm || !form) return;

/*
 * Si había otro selector abierto, liberamos
 * la tarjeta anterior.
 */
if (active?.opener && active.opener !== opener) {
  active.opener.setAttribute('aria-expanded', 'false');
  active.card?.classList.remove('tp-card-picker-open');
}

active = {
  opener,
  container,
  productForm,
  form,
  card
};

/*
 * Mantiene visibles Añadir al carrito / + Info
 * aunque el ratón salga de la tarjeta.
 */
card?.classList.add('tp-card-picker-open');

    populate(productForm);
    root.hidden = false;
    opener.setAttribute('aria-expanded', 'true');
    applyMode();

    requestAnimationFrame(() => {
      if (!MOBILE_QUERY.matches) positionDesktop();
      root.querySelector('[data-tp-picker-qty="1"]')?.focus({ preventScroll: true });
    });
  }

  function closePicker(returnFocus = false) {
    if (!root || root.hidden) return;

    const opener = active?.opener || null;
const card = active?.card || null;

root.hidden = true;
root.classList.remove('is-mobile', 'is-desktop');
panel?.removeAttribute('style');
unlockScroll();

if (opener) {
  opener.setAttribute('aria-expanded', 'false');

  if (returnFocus) {
    opener.focus({ preventScroll: true });
  }
}

/*
 * Restauramos el comportamiento hover normal
 * cuando el selector se cierra.
 */
card?.classList.remove('tp-card-picker-open');

active = null;
  }

  function submitQuantity(qty) {
  if (!active || ![1, 3, 5].includes(qty)) return;

  /*
   * Guardamos las referencias ANTES de cerrar el picker,
   * porque closePicker() pone active = null.
   */
  const form = active.form;
  const productForm = active.productForm;

  if (!form || !productForm) return;

  const quantityInput = form.querySelector(
    '[data-tp-card-quantity-input]'
  );

  if (!quantityInput) return;

  /*
   * Exactamente la misma información que usa la PDP:
   * name="quantity" con 1, 3 o 5.
   */
  quantityInput.value = String(qty);
  quantityInput.setAttribute('value', String(qty));

  quantityInput.dispatchEvent(
    new Event('input', {
      bubbles: true
    })
  );

  quantityInput.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );

  /*
   * Cerramos primero nuestro selector para que no interfiera
   * visualmente con la apertura del cart drawer.
   */
  closePicker(false);

  /*
   * Disparamos el MISMO evento submit que genera el botón
   * "Añadir al carrito" de la PDP.
   *
   * Aurora tiene su listener en el <form>, intercepta este submit,
   * crea el FormData y gestiona:
   * - /cart/add
   * - cantidad
   * - errores de stock
   * - refresco del carrito
   * - apertura del cart drawer
   */
  const submitEvent = new Event('submit', {
    bubbles: true,
    cancelable: true
  });

  form.dispatchEvent(submitEvent);
}

  document.addEventListener('click', (event) => {
    const opener = event.target.closest(OPEN_BUTTON_SELECTOR);

    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      openPicker(opener);
      return;
    }

    if (!root || root.hidden) return;

    const quantityButton = event.target.closest('[data-tp-picker-qty]');

    if (quantityButton) {
      event.preventDefault();
      event.stopPropagation();
      submitQuantity(parseInt(quantityButton.dataset.tpPickerQty || '0', 10));
      return;
    }

    if (event.target.closest('[data-tp-picker-close]')) {
      event.preventDefault();
      event.stopPropagation();
      closePicker(true);
      return;
    }

    if (event.target === backdrop || event.target.closest('[data-tp-picker-backdrop]')) {
      event.preventDefault();
      event.stopPropagation();
      closePicker(true);
      return;
    }

    if (!MOBILE_QUERY.matches && !event.target.closest('[data-tp-picker-panel]')) {
      closePicker(false);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root && !root.hidden) {
      event.preventDefault();
      closePicker(true);
    }
  });

  window.addEventListener('scroll', () => {
    if (active && !MOBILE_QUERY.matches) positionDesktop();
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (!active) return;
    applyMode();
  });
})();
